// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__37PKd","itemTitle":"ClientEmergencyInfo_itemTitle__3_pI3","itemText":"ClientEmergencyInfo_itemText__E_3qq"};